import React, { useEffect, useState } from 'react';
import { firestore } from './firebaseConfig';
import { collection, getDocs } from 'firebase/firestore';
import './MagazineOutput.css';

const MagazineOutput = () => {
  const [magazines, setMagazines] = useState([]);

  useEffect(() => {
    const fetchMagazines = async () => {
      try {
        const magazinesCollection = collection(firestore, 'magazines');
        const magazinesSnapshot = await getDocs(magazinesCollection);
        setMagazines(magazinesSnapshot.docs.map((doc) => doc.data()));
      } catch (error) {
        console.error('Error fetching magazines:', error);
      }
    };

    fetchMagazines();
  }, []);

  return (
    <div className="magazine-container">
      <h2>Magazines</h2>
      {magazines.length === 0 ? (
        <p>No magazines available yet.</p>
      ) : (
        <div className="magazine-grid">
          {magazines.map((magazine, index) => (
            <div key={index} className="magazine-item">
              <img
                src={magazine.imageUrl}
                alt={magazine.name}
                className="magazine-image"
                onClick={() => window.open(magazine.pdfUrl, '_blank')}
              />
              <div className="magazine-name">{magazine.name}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MagazineOutput;
